import { useState, useEffect } from "react";

// Persist a piece of form state to localStorage so drafts survive reloads / closing the session.
export function useDraft(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const s = localStorage.getItem(key);
      return s != null ? JSON.parse(s) : initial;
    } catch { return initial; }
  });
  useEffect(() => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* noop */ }
  }, [key, value]);
  return [value, setValue];
}

export function clearDraft(key) {
  try { localStorage.removeItem(key); } catch { /* noop */ }
}
